import { useState, useEffect } from "react";
import Select from "react-select";
import countries from "world-countries";

import SocialField from "../../../../components/SocialField";
import UploadFile from "../../../../components/UploadFile";
import SalaryField from "../../../../components/SalaryField";
import deleteIcon from "../../../../assets/delete-icon.svg";
import plusIcon from "../../../../assets/plus-button.svg";

import linkedinIcon from "../../../../assets/linkedin-img.svg";
import telegramIcon from "../../../../assets/telegram-i.svg";
import xIcon from "../../../../assets/x-icon-img.svg";
import facebookIcon from "../../../../assets/facebook-img.svg";
import youtubeIcon from "../../../../assets/youtube-img.svg";

import SearchSkillsAll from "../../../../components/SearchSkillsAll";

export default function EditCompanyFields({
  handleFileChange,
  handleChange,
  details,
  handleLocationChange,
  handleDeleteLocation,
  handleAddLocation,
  handleSkillsChange,
}) {
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    setLocations(details.locations || []);
  }, [details.locations]);

  const countryOptions = countries.map((country) => ({
    value: country.name.common,
    label: country.name.common,
  }));

  const updateLocation = (id, field, value) => {
    const updated = locations.map((loc) =>
      loc.id === id ? { ...loc, [field]: value } : loc
    );

    setLocations(updated);
    handleLocationChange(updated);
  };

  const handleLocationDelete = (id) => {
    const updated = locations.filter((loc) => loc.id !== id);

    setLocations(updated);
    handleDeleteLocation(id);
  };

  return (
    <div className="company-profile-fields-wrapper">
      <UploadFile handleFileChange={handleFileChange} />
      <div className="form-group">
        <label>Company Name</label>
        <input
          required
          type="text"
          name="company_name"
          onChange={handleChange}
          value={details?.company_profile.company_name}
        />
      </div>
      <div className="form-group">
        <label>Website</label>
        <input
          required
          type="url"
          name="website"
          onChange={handleChange}
          value={details?.company_profile.website}
        />
      </div>
      <div className="form-group">
        <label>About Company</label>
        <textarea
          required
          name="bio"
          onChange={handleChange}
          value={details?.company_profile.bio}
        ></textarea>
      </div>
      <SearchSkillsAll
        handleSkillsChange={handleSkillsChange}
        details={details?.company_profile}
      />
      <div className="separator"></div>
      <div className="form-group">
        <label>Employee Count</label>
        <select
          required
          name="employee_count"
          value={details?.company_profile.employee_count}
          onChange={handleChange}
        >
          <option value="0 to 10">0 to 10</option>
          <option value="10 to 50">10 to 50</option>
          <option value="50 to 100">50 to 100</option>
          <option value="100 to 200">100 to 200</option>
          <option value="200 to 500">200 to 500</option>
          <option value="500+">500+</option>
        </select>
      </div>
      <SalaryField
        label="Total Funding"
        name="total_funding"
        placeholder="150,000,000"
        handleInput={handleChange}
        value={details?.company_profile.total_funding}
      />
      <SalaryField
        label="Revenue"
        name="revenue"
        placeholder="150,000,000"
        handleInput={handleChange}
        value={details?.company_profile.revenue}
      />
      <div className="form-group">
        <label>Last Funding Round</label>
        <select
          required
          name="last_funding_round"
          value={details?.company_profile.last_funding_round}
          onChange={handleChange}
        >
          <option value="Series A">Series A</option>
          <option value="Series B">Series B</option>
          <option value="Series C">Series C</option>
          <option value="Series D">Series D</option>
          <option value="Series E">Series E</option>
        </select>
      </div>
      <div className="separator"></div>
      <div className="form-group">
        <label>Customers</label>
        <textarea
          placeholder="Phillips, Nokia"
          name="customers"
          onChange={handleChange}
          value={details?.company_profile.customers}
        ></textarea>
      </div>
      <div className="company-locations-wrapper">
        <div className="separator"></div>
        <label>Location Details</label>
        <input
          type="hidden"
          name="locations"
          value={JSON.stringify(locations)}
        />
        <div className="company-locations-single-parent">
          {locations.length === 0 ? (
            <p>No Locations</p>
          ) : (
            locations.map((curr) => (
              <div className="company-locations-single-wrapper" key={curr.id}>
                <div className="form-group form-group-country-select">
                  <label>HQ Location</label>
                  <Select
                    options={countryOptions}
                    name="country"
                    value={
                      countryOptions.find(
                        (option) => option.value === curr.country
                      ) || null
                    }
                    onChange={(selectedOption) => {
                      const updated = locations.map((loc) =>
                        loc.id === curr.id
                          ? { ...loc, country: selectedOption.value }
                          : loc
                      );
                      setLocations(updated);
                      updateLocation(curr.id, "country", selectedOption.value);
                    }}
                    placeholder="Select a country"
                    isSearchable
                  />
                </div>
                <div className="row-essy">
                  <div className="col-essy-md-12 col-essy-lg-7">
                    <div className="form-group">
                      <label>City</label>
                      <input
                        required
                        type="text"
                        name="city"
                        value={curr.city}
                        onChange={(e) =>
                          updateLocation(curr.id, "city", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-essy-md-12 col-essy-lg-5">
                    <div className="form-group">
                      <label>Zip</label>
                      <input
                        required
                        type="number"
                        name="postal_code"
                        value={curr.postal_code}
                        maxLength="10"
                        onChange={(e) =>
                          updateLocation(curr.id, "postal_code", e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input
                    required
                    type="text"
                    name="address"
                    value={curr.address}
                    onChange={(e) =>
                      updateLocation(curr.id, "address", e.target.value)
                    }
                  />
                </div>
                <div className="form-group">
                  <label>State</label>
                  <input
                    required
                    type="text"
                    name="state"
                    value={curr.state}
                    onChange={(e) =>
                      updateLocation(curr.id, "state", e.target.value)
                    }
                  />
                </div>
                <div className="remove-wrapper">
                  <button
                    type="button"
                    onClick={() => handleLocationDelete(curr.id)}
                  >
                    <img src={deleteIcon} alt="delete icon" />
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="add-button-all">
          <button type="button" onClick={handleAddLocation}>
            <img src={plusIcon} alt="plus" />
            Add Location
          </button>
        </div>
      </div>
      <div className="profil-edit-social-wrapper">
        <div className="separator"></div>
        <span>Social</span>
        <SocialField
          icon={linkedinIcon}
          alt="linkedin"
          value={details?.company_profile.linkedin}
          handleInput={handleChange}
          name="linkedin"
          placeholder="https://linkedin.com/"
        />
        <SocialField
          icon={telegramIcon}
          alt="telegram"
          value={details?.company_profile.telegram}
          handleInput={handleChange}
          name="telegram"
          placeholder="https://telegram.org/"
        />
        <SocialField
          icon={xIcon}
          alt="x"
          value={details?.company_profile.twitter}
          handleInput={handleChange}
          name="twitter"
          placeholder="https://x.com/"
        />
        <SocialField
          icon={facebookIcon}
          alt="facebook"
          value={details?.company_profile.facebook}
          handleInput={handleChange}
          name="facebook"
          placeholder="https://facebook.com/"
        />
        <SocialField
          icon={youtubeIcon}
          alt="youtube"
          value={details?.company_profile.youtube}
          handleInput={handleChange}
          name="youtube"
          placeholder="https://youtube.com/"
        />
      </div>
    </div>
  );
}
